module.exports = __webpack_public_path__ + "img/cs_set.206fa217.gif";